module.exports = __webpack_public_path__ + "img/clcrf.657f37c.png";